export default "__VITE_ASSET__v3KaMHv8__ 640w, __VITE_ASSET__s7EW4zqw__ 1024w, __VITE_ASSET__Dtb7QAk3__ 1920w";